var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.35,
    stroke: "#886CC0",
    strokeWidth: 1.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13639 7.76135L10 5.10344L10.8636 7.76135C11.0042 8.19397 11.4073 8.48688 11.8622 8.48688H14.6569L12.396 10.1296C12.0279 10.3969 11.874 10.8709 12.0145 11.3035L12.8781 13.9614L10.6172 12.3187L10.2351 12.8446L10.6172 12.3187C10.2492 12.0513 9.75084 12.0513 9.38283 12.3187L9.76489 12.8446L9.38283 12.3187L7.12188 13.9614L7.98548 11.3035C8.12605 10.8709 7.97206 10.3969 7.60405 10.1296L5.3431 8.48688H8.13778C8.59267 8.48688 8.99583 8.19397 9.13639 7.76135ZM15.2794 8.03463L15.2788 8.03502L15.2794 8.03463ZM4.72062 8.03463C4.72071 8.03469 4.72079 8.03475 4.72088 8.03481L4.72062 8.03463L4.57368 8.23688L4.72062 8.03463Z",
    fill: "#886CC0",
    stroke: "#886CC0",
    strokeWidth: 1.3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpert);
export default __webpack_public_path__ + "static/media/expert.1262006e5e96a17d65b480df132ac675.svg";
export { ForwardRef as ReactComponent };